/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const updateTeamRoleRequestSchema = z.object({
  isCritical: z.boolean().nullish(),
  isDefault: z.boolean().nullish(),
  name: z.string().nullish(),
});
